import React from 'react';
import PropTypes from 'prop-types';
import Menu from './Menu';
import {
  NewTxn, EditTxn,
  NewAccount, EditAccount
} from 'forms';
import Reminder from 'views/Khata/Reminder';
import RecursivetxnsView from 'views/Khata/RecursiveTxn';
import RecursiveTxns from 'forms/Recursive/AddAndEditRTxns';

const FORM_CONFIGS = {
  'menu': {
    title: 'Menu',
    icon: '',
    position: 'end',
    component: Menu,
  },
  'newAccount': {
    title: 'Add Account',
    icon: 'bi bi-person-plus',
    position: 'start',
    component: NewAccount,
  },
  'editAccount': {
    title: 'Account Details',
    icon: 'bi bi-person',
    position: 'start',
    component: EditAccount,
  },
  'newTxn': {
    title: 'Add Transaction',
    icon: 'bi bi-plus-circle',
    position: 'end',
    component: NewTxn,
  },
  'editTxn': {
    title: 'Edit Transaction',
    icon: 'bi bi-pencil',
    position: 'end',
    component: EditTxn,
  },
  'reminder': {
    title: 'Reminder',
    icon: 'bi bi-alarm',
    position: 'end',
    component: Reminder,
  },
  'recursiveTxns': {
    title: 'Recurring Transactions',
    icon: 'bi bi-arrow-repeat',
    position: 'end',
    component: RecursivetxnsView,
  },
  'editRecursiveTxn': {
    title: 'Edit Recurring Transaction',
    icon: 'bi bi-pencil',
    position: 'end',
    component: RecursiveTxns,
  },
};

const DynamicOffcanvas = ({
  formType,
  onHide,
  onShow,
  className = '',
  width,
  ...props
}) => {
  const config = FORM_CONFIGS[formType];
  if (!config) return null;

  const { title, icon, position, component: Component } = config;

  React.useEffect(() => {
    const offCanvas = document.getElementById('dynamicOffcanvas');
    if (!offCanvas) return;

    const handleHidden = () => {
      if (onHide) onHide();
    };

    const handleShown = () => {
      if (onShow) onShow();
    };

    offCanvas.addEventListener('hidden.bs.offcanvas', handleHidden);
    offCanvas.addEventListener('shown.bs.offcanvas', handleShown);

    return () => {
      offCanvas.removeEventListener('hidden.bs.offcanvas', handleHidden);
      offCanvas.removeEventListener('shown.bs.offcanvas', handleShown);
    };
  }, [onHide, onShow]);

  return (
    <div
      className={`offcanvas offcanvas-${position} ${className}`}
      tabIndex="-1"
      id="dynamicOffcanvas"
      style={width ? { '--bs-offcanvas-width': width } : undefined}
    >
      <div className="offcanvas-header bg-app justify-content-center">
        <h3 className="offcanvas-title text-light">
          {icon && <i className={`${icon} me-2 fs-2`} />}
          <span>{title}</span>
        </h3>
        <button
          type="button"
          className="btn-close text-reset bg-light position-absolute end-0 me-3"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        />
      </div>
      <div className={`offcanvas-body ${className}`}>
        <Component {...props} />
      </div>
    </div>
  );
};

DynamicOffcanvas.propTypes = {
  formType: PropTypes.oneOf(Object.keys(FORM_CONFIGS)).isRequired,
  onHide: PropTypes.func,
  onShow: PropTypes.func,
  className: PropTypes.string,
  width: PropTypes.string,
};

export default DynamicOffcanvas; 